import React from 'react';
import { Loader2 } from 'lucide-react';
import KBIcon from './KBIcon';

const KBLoadingScreen = () => (
  <div className="kb-loading-screen">
    <KBIcon size={48} />
    <Loader2 size={24} className="kb-spin" />
    <p>Loading knowledge base...</p>
  </div>
);

export default KBLoadingScreen;
